<template>
    <div>
      <header>
        <v-container>
          <v-row no-gutters>
            <h1 class="font-weight-light headline">
              {{ $t("title.moduls") }}
            </h1>
            <v-spacer></v-spacer>
            <v-lazy v-if="isStudentsLoaded" transition="fade-transition">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="searchLabel"
                single-line
                dense
                hide-details
                style="max-width: 200px"
                class="mr-5 pr-5"
              ></v-text-field>
            </v-lazy>
            <v-lazy transition="fade-transition">
              <v-btn
                color="success"
                dark
                small
                @click.stop="
                  dialog.moduleForm = true;
                  isStudentEdited = false;
                "
                >{{ $t("general.add") }}</v-btn
              >
            </v-lazy>
          </v-row>
        </v-container>
      </header>
      <section class="py-7">
        <v-container>
          <v-sheet class="px-3 pt-3 pb-3" v-if="!isStudentsLoaded">
            <v-skeleton-loader class="mx-auto" type="table"></v-skeleton-loader>
          </v-sheet>
          <v-card v-else>
            <v-data-table :headers="headers" :items="moduls" :search="search">
              <template v-slot:item.action="{ item }">
                <div style="display: flex">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-tr-class-on-hover="'blue'"
                        size="20px"
                        color="blue"
                        class="mr-2"
                        @click="editUser(item)"
                        v-on="on"
                        >mdi-pencil-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("general.edit") }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        size="22px"
                        color="red"
                        v-tr-class-on-hover="'red'"
                        class="mr-2"
                        @click="confirmDelete(item)"
                        v-on="on"
                        >mdi-delete-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("general.delete") }}</span>
                  </v-tooltip>
                </div>
              </template>
              <template v-slot:item.is_active="{ item }">
                <v-switch
                  class="mt-0 pt-0 justify-content-center"
                  hide-details
                  color="green"
                  v-model="item.is_active"
                  @change="changeStatus(item)"
                ></v-switch>
              </template>
            </v-data-table>
          </v-card>
          <ModuleForm
            :student="selectedStudent"
            :visible="dialog.moduleForm"
            :isEdited="isStudentEdited"
            :variables="variables"
            @addStudent="addStudent"
            @updateStudent="updateStudent"
            @close="dialog.moduleForm = false"
            @snackMessage="snackMessage"
          />
  
          <ConfirmationDialog
            :name="selectedStudent.name"
            :text="'students.delete_confirmation'"
            v-if="dialog.confirmation"
            @confirm="deleteStudent"
            @cancel="cancelDelete"
          />
  
          <SnackMessage ref="SnackMessage" />
        </v-container>
      </section>
    </div>
  </template>
  
  <script>
  import ModuleForm from "../components/ModuleForm.vue";
  import ConfirmationDialog from "../components/ConfirmationDialog";
  import SnackMessage from "../components/SnackMessage";
  
  export default {
    data() {
      return {
        moduls: [],
        isStudentsLoaded: false,
        search: "",
        dialog: {
          confirmation: false,
          moduleForm: false,
        },
        student: {
          name: null,
          id: null,
          is_active: null,
        },
        selectedStudent: {
          name: null,
          id: null,
          is_active: null,
        },
        defaultStudent: {
          name: null,
          id: null,
          is_active: null,
        },
        isStudentEdited: false,
        variables: {
          app_domain: "",
          is_division: "",
          is_errors_available: "",
          app_name: "",
        },
      };
    },
  
    components: {
      ModuleForm,
      ConfirmationDialog,
      SnackMessage,
    },
  
    computed: {
      headers() {
        
          return [
            {
              text: this.$t("general.actions"),
              value: "action",
              sortable: false,
            },
            {
              text: this.$t("modul.name"),
              align: "left",
              sortable: false,
              value: "name",
            },
            {
              text: this.$t("general.active"),
              align: "left",
              sortable: false,
              value: "is_active",
            },
          ];
      },
      searchLabel() {
        return this.$t("general.search");
      },
    },
  
    created() {
      this.getStudents();
      this.getVariables();
    },
  
    methods: {
      getVariables() {
        axios
          .get("/getVariables", {
            headers: {
              Authorization:
                "Bearer " + this.$store.state.tokenData.user.access_token,
            },
          })
          .then((response) => {
            this.variables = response.data;
          });
      },
      snackMessage(msg, type) {
        this.$refs.SnackMessage.showMessage(msg, type);
      },
      async getStudents() {
  
        await axios
          .get("/moduls", {
            headers: {
              Authorization:
                "Bearer " + this.$store.state.tokenData.user.access_token,
            },
          })
          .then((response) => {
             this.moduls = response.data;
             this.isStudentsLoaded = true;
          })
          .catch((error) => {
            console.log(error.response.data);
          });
      },
      addStudent(modul) {
        this.moduls.push(modul);
        this.getStudents();
      },
      editUser(item) {
        this.selectedStudent = Object.assign({}, item);
        this.dialog.moduleForm = true;
        this.isStudentEdited = true;
      },
      updateStudent(student) {
        let index = this.moduls.findIndex((item) => item.id == student.id);
        this.moduls.splice(index, 1, student);
        this.getStudents();
      },
      confirmDelete(item) {
        this.selectedStudent = item;
        this.dialog.confirmation = true;
      },
      cancelDelete() {
        this.dialog.confirmation = false;
      },
      async deleteStudent() {
        this.dialog.confirmation = false;
        let index = this.moduls.indexOf(this.selectedStudent);
  
        await axios
          .delete(`/deleteModule/${this.selectedStudent.id}`, {
            headers: {
              Authorization:
                "Bearer " + this.$store.state.tokenData.user.access_token,
            },
          })
          .then((response) => {
            this.selectedStudent = this.defaultStudent;
            this.moduls.splice(index, 1);
  
            this.$refs.SnackMessage.showMessage(
              "students.deleted_successfully",
              "success"
            );
          })
          .catch((error) => {
            console.log(error);
            this.$refs.SnackMessage.showMessage("general.error", "error");
          });
      },
      async changeStatus(item) {
        try {
          const request = await axios.put(
            "/updateStatusModul/" + item.id,
            item,
            {
              headers: {
                Authorization:
                  "Bearer " + this.$store.state.tokenData.user.access_token,
              },
            }
          );
          this.getStudents();
          this.snackMessage("general.item_saved", "success");
        } catch (error) {
          console.error(error);
        }
      },
    },
  };
  </script>
  